// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.email-content{
    display:flex;
    flex-direction: column;
    font-family: "PlusJakartaSans";
    
  }
  .email-content > div{
      width:100%;
  }
  .meeting-content-label{
    margin-bottom:0.5rem;
}
.meeting-footer{
    display:flex;
    justify-content: flex-end;
    align-items: center;
}
.email-body{
    display:flex;
    flex-direction: column;
    font-family: "PlusJakartaSans";
    margin-top:2rem;
}
.email-to-container,.email-subject-container,.email-body-container{
    width:100%;
    border:1px solid rgb(231, 234, 237);
    display:flex;
    align-items: center;
    justify-content: space-between;
}

.email-to-container{
    border-radius: 5px 5px 0px 0px;

}

.email-to-container > label,.email-subject-container > label{
    display:flex;
    align-items: center;
    justify-content: center;
    margin:0;
}
.email-body-textarea{
    width:100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 250px;
    padding: 10px;
    border:none;
    border-radius:0.25rem;
    resize:none;
}

.para{
    padding: 10px;

}

.email-input-field{
        width: 100%;
    border: none;
    height: 44px;
}


.email-file-upload{
    width:100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    padding: 10px;
    border-radius: 0px 0px 5px 5px;
    resize:none;
    border: 1px solid rgb(231, 234, 237);
background-color: #f4f6f8;
}

.report-upload-files{
 margin-bottom:0px
}

.upload-files {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 20px;
}

.email-file {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f4f6f8;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  max-width: 400px;
}

.email-file p {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.email-file div {
  cursor: pointer;
  color: #666;
  margin-left: 10px;
}

.file-info {
  display: flex;
  align-items: center;
}

.file-info img {
  margin-right: 10px; /* Adjust margin as needed */
}

.email-file div:hover {
  color: #333;
}
`, "",{"version":3,"sources":["webpack://./src/pages/report/components/EmailPopup.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,sBAAsB;IACtB,8BAA8B;;EAEhC;EACA;MACI,UAAU;EACd;EACA;IACE,oBAAoB;AACxB;AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,sBAAsB;IACtB,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,UAAU;IACV,mCAAmC;IACnC,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;;AAElC;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;AACA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,aAAa;IACb,WAAW;IACX,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,aAAa;;AAEjB;;AAEA;QACQ,WAAW;IACf,YAAY;IACZ,YAAY;AAChB;;;AAGA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,oCAAoC;AACxC,yBAAyB;AACzB;;AAEA;CACC;AACD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB,EAAE,4BAA4B;AAClD;;AAEA;EACE,WAAW;AACb","sourcesContent":[".email-content{\r\n    display:flex;\r\n    flex-direction: column;\r\n    font-family: \"PlusJakartaSans\";\r\n    \r\n  }\r\n  .email-content > div{\r\n      width:100%;\r\n  }\r\n  .meeting-content-label{\r\n    margin-bottom:0.5rem;\r\n}\r\n.meeting-footer{\r\n    display:flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n}\r\n.email-body{\r\n    display:flex;\r\n    flex-direction: column;\r\n    font-family: \"PlusJakartaSans\";\r\n    margin-top:2rem;\r\n}\r\n.email-to-container,.email-subject-container,.email-body-container{\r\n    width:100%;\r\n    border:1px solid rgb(231, 234, 237);\r\n    display:flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.email-to-container{\r\n    border-radius: 5px 5px 0px 0px;\r\n\r\n}\r\n\r\n.email-to-container > label,.email-subject-container > label{\r\n    display:flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin:0;\r\n}\r\n.email-body-textarea{\r\n    width:100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    height: 250px;\r\n    padding: 10px;\r\n    border:none;\r\n    border-radius:0.25rem;\r\n    resize:none;\r\n}\r\n\r\n.para{\r\n    padding: 10px;\r\n\r\n}\r\n\r\n.email-input-field{\r\n        width: 100%;\r\n    border: none;\r\n    height: 44px;\r\n}\r\n\r\n\r\n.email-file-upload{\r\n    width:100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    height: 40px;\r\n    padding: 10px;\r\n    border-radius: 0px 0px 5px 5px;\r\n    resize:none;\r\n    border: 1px solid rgb(231, 234, 237);\r\nbackground-color: #f4f6f8;\r\n}\r\n\r\n.report-upload-files{\r\n margin-bottom:0px\r\n}\r\n\r\n.upload-files {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.email-file {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background-color: #f4f6f8;\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n  width: 100%;\r\n  max-width: 400px;\r\n}\r\n\r\n.email-file p {\r\n  margin: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.email-file div {\r\n  cursor: pointer;\r\n  color: #666;\r\n  margin-left: 10px;\r\n}\r\n\r\n.file-info {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.file-info img {\r\n  margin-right: 10px; /* Adjust margin as needed */\r\n}\r\n\r\n.email-file div:hover {\r\n  color: #333;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
